// src/components/PublicLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const PublicLayout = () => {
  return (
    <div className="public-layout public-layout--light">
      <Outlet />
      <Footer />
    </div>
  );
};

export default PublicLayout;
